type ParseOk = { ok: true; value: string };
type ParseErr = { ok: false; error: string };
type ParseResult = ParseOk | ParseErr;

/**
 * Formats a raw multiplier string (as serialised by BE NUMERIC(4,3)) to
 * exactly 3 decimal places using the dot separator.
 * Returns "0.000" for empty/non-numeric input.
 */
export function formatMultiplier(raw: string): string {
  const n = parseFloat(raw);
  if (!Number.isFinite(n)) return "0.000";
  return n.toFixed(3);
}

/**
 * Validates user input for a multiplier field.
 * Rejects comma separators (B15 fix from old app), values outside [0,1].
 * On success, returns value normalised to 3 decimal places.
 */
export function parseMultiplier(input: string): ParseResult {
  if (input.trim() === "") return { ok: false, error: "Required" };
  if (input.includes(",")) return { ok: false, error: "Use '.' as decimal separator" };
  const n = parseFloat(input);
  if (!Number.isFinite(n)) return { ok: false, error: "Must be a number" };
  if (n < 0) return { ok: false, error: "Must be ≥ 0" };
  if (n > 1) return { ok: false, error: "Must be ≤ 1" };
  return { ok: true, value: n.toFixed(3) };
}
